import { FormikInput, IconWithText } from '../../../../../web.common';
import React from 'react';
import { fieldTypes } from '../../../../../enums/FieldTypes';

export const fields = (isEditMode, { Id, Name, Type, IsRequired, ProductId }) => [{
  Id,
  'Name*': isEditMode
    ? <FormikInput name='Name' description='Name' placeholder required />
    : Name,
  'Type*': isEditMode
    ? (
      <FormikInput
        name='Type'
        description='Type'
        type='select'
        options={Object.keys(fieldTypes).map(x => ({ value: x, label: x }))}
        placeholder
        required
      />
    )
    : Type,
  'Is Required': isEditMode
    ? <FormikInput type='checkbox' name='IsRequired' description='IsRequired' label='' placeholder required />
    : (
      <IconWithText
        iconName={IsRequired ? 'check' : 'times'}
        iconClasses={[`text-color-${IsRequired ? 'success' : 'danger'}`]}
        text={`Field is ${IsRequired ? 'required' : 'not required'}`}
      />
    ),
  'Product Id': ProductId
}];